export default "__VITE_ASSET__7Qp7Grhp__"